import { HttpAxiosRequest } from '../httpAxiosBase'
import { DictionarySecurityObject } from 'src/types/security'

export const HttpCacheSecurityObject = {
    getEndpoint: (url = ''): string => `cache/objetos/seguridad${url}`,

    getByUser: (): Promise<DictionarySecurityObject> => HttpAxiosRequest.get(HttpCacheSecurityObject.getEndpoint())
}
